import { lazy } from 'react';

import type { TApplicationRoute } from '@modules/core/types';

import { CONTENT_ROUTE_PATHS } from './config';

export const CONTENT_ROUTES: TApplicationRoute[] = [
  {
    id: 'help-center-content',
    path: CONTENT_ROUTE_PATHS.content,
    component: lazy(() => import('./pages/content-page')),
    layout: 'default',
    permissions: { scopes: ['help-center'] },
    menu: {
      title: 'pages.helpCenter.content.title',
    },
  },
];
